import {
  Coverage,
  Duration,
  getDisabilityRiderMaxCoverage,
  isWholeLife,
  JobRiskClass,
  PersonInsuranceType,
  RiderType,
} from '@emma-labs/shared/typescript';

export function getSelectedCoverageAmount(
  selectedCoverage: Coverage,
  type: PersonInsuranceType,
): number | undefined {
  const selectedTermDuration = Object.keys(selectedCoverage.lifeInsurances).find((duration) =>
    type === 'WHOLE' ? isWholeLife(duration) : !isWholeLife(duration),
  );

  return selectedTermDuration ? selectedCoverage.lifeInsurances?.[selectedTermDuration] : undefined;
}

export function getUpdatedLifeInsuranceCoverage(
  selectedCoverage: Coverage,
  amount: number | undefined,
  duration: Duration,
  jobRiskClass?: JobRiskClass,
): Coverage {
  const isWholeUpdate = isWholeLife(duration);
  const previouslySelectedDuration = Object.keys(selectedCoverage.lifeInsurances).find((duration) =>
    isWholeUpdate ? isWholeLife(duration) : !isWholeLife(duration),
  );

  if (previouslySelectedDuration) {
    delete selectedCoverage.lifeInsurances[previouslySelectedDuration];
  }

  if (amount && duration) {
    selectedCoverage.lifeInsurances[duration] = amount;
  }

  if (selectedCoverage.riders) {
    const termLifeCoverageAmount = getSelectedCoverageAmount(selectedCoverage, 'TERM') ?? 0;
    const wholeLifeCoverageAmount = getSelectedCoverageAmount(selectedCoverage, 'WHOLE') ?? 0;
    const totalCoverage = termLifeCoverageAmount + wholeLifeCoverageAmount;

    selectedCoverage.riders = selectedCoverage.riders.filter((rider) => {
      if (rider.type === RiderType.CHILD) {
        return totalCoverage >= rider.coverage * 2;
      }

      if (rider.type === RiderType.DISABILITY && jobRiskClass) {
        return rider.coverage <= getDisabilityRiderMaxCoverage(totalCoverage, jobRiskClass);
      }

      return true;
    });
  }

  return selectedCoverage;
}

export function getUpdatedRiderCoverage(
  selectedCoverage: Coverage,
  amount: number | undefined,
  duration: number | undefined,
  type: RiderType,
): Coverage {
  selectedCoverage.riders ??= [];
  const riderIndex = selectedCoverage.riders.findIndex((rider) => rider.type === type);

  if (amount) {
    const newRider = {type, coverage: amount, duration};

    riderIndex !== -1
      ? (selectedCoverage.riders[riderIndex] = newRider)
      : selectedCoverage.riders.push(newRider);
  } else if (riderIndex !== -1) {
    selectedCoverage.riders.splice(riderIndex, 1);
  }

  return selectedCoverage;
}
